import React, { useEffect, useState } from 'react';
import { Modal, Input, Form, Button, Select } from 'antd';
import { getPaymentMethodFromString } from 'app/utils/paymentUtils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEleve, getPhoto } from '../eleve/eleve.reducer';
import { RouteComponentProps } from 'react-router-dom';
import { getSalaireById, relanceSalairePayment } from './salaire.reducer';

const PaymentModal = (props: RouteComponentProps<{ salaireId: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const salaire = useAppSelector(state => state.salaire.entity);
  const [form] = Form.useForm();
  const moyenPaiements = ['WAVE', 'OM'];
  useEffect(() => {
    dispatch(getSalaireById(props.match.params.salaireId));
  }, []);

  const handlePay = () => {
    form.validateFields().then(values => {
      const entity = {
        salaireId: props.match.params.salaireId,
        numeroPaiement: values.numeroPaiement,
        moyenPaiement: values.moyenPaiement,
      };
      dispatch(relanceSalairePayment(entity));
      form.resetFields();
      goBack();
    });
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {salaire.id !== null && (
        <Modal
          title="Confirmation de paiement"
          centered
          footer={[
            <Button key="back" type="primary" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: 'green', color: 'white' }} onClick={handlePay}>
              Payer
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Veuillez renseigner les champs ci-dessous pour relancer le paiement du salaire:
          <Form form={form} layout="vertical" name="paymentForm">
            <Form.Item label="Préference de Paiement" name="moyenPaiement" rules={[{ required: true }]}>
              <Select placeholder="Moyen de Paiement du salaire" style={{ width: '100%' }} optionFilterProp="children">
                {moyenPaiements.map((moyen, i) => (
                  <Select.Option key={i} value={moyen}>
                    {getPaymentMethodFromString(moyen)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Numéro de Téléphone de Paiement"
              name="numeroPaiement"
              rules={[{ required: true, min: 9, max: 9, message: 'ce champs doit contenir 9 chiffres' }]}
            >
              <Input placeholder="Téléphone" type="number" />
            </Form.Item>

            <Form.Item
              name="confirmPaymentNumber"
              label="Confirmez le numéro de paiement"
              dependencies={['numeroPaiement']}
              rules={[
                { required: true, message: 'Veuillez confirmer le numéro de paiement !' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('numeroPaiement') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Les deux numéros de paiement ne correspondent pas !'));
                  },
                }),
              ]}
            >
              <Input placeholder="Confirmez le numéro de paiement" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default PaymentModal;
